<template>
<div class="chapter">
<div class="inner_page">
<h3 class="center">THE NEW YORK YANKEES OF 1949</h3>
<h3 class="center">Casey Stengel—Manager</h3>
<p class="center" style="margin-top:20px;"><span><img alt="" src="Book1/image001.png"/></span></p>
<p class="center" style="margin-top:20px;"><span><img alt="" src="Book1/image002.png"/></span></p>
<h3 class="center" style="margin-top:20px;">THE BOSTON RED SOX OF 1949</h3>
<h3 class="center">Joe McCarthy—Manager</h3>
<p class="center" style="margin-top:20px;"><span><img alt="" src="Book1/image003.png"/></span></p>
<p class="center" style="margin-top:20px;"><span><img alt="" src="Book1/image004.png"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 6-chap1.vue?60d2fdf7